<template>
  <div>
    <div class="style-2 home s-2 bottom-3">

      <div class="container clearfix">

        <div class="row">
        <div class="sixteen columns bottom-3">

          <h3 class="title bottom-2">{{ $t('ref_test_main') }}</h3>

          <carousel :perPage="1"
                    :loop="true"
                    autoplay
                    autoplayHoverPause
                    :speed="300"
                    :autoplayTimeout="12000"
                    navigationEnabled
                    :navigationClickTargetSize="12"
                    :paginationEnabled="false">

            <slide v-for="(testimonial,index) in testimonials" :key="index">
              <div class="testimonials">
                <div class="testimonial-item">
                  <p>
                    {{ $t(testimonial.text) }}
                  </p>
                  <div class="testimonials-arrow"></div>
                  <div class="author">
                    <span class="color">{{ testimonial.name }}</span>, {{ $t(testimonial.title) }}
                  </div>
                </div>
              </div>
            </slide>
          </carousel>
        </div>
        </div>

        <div class="row">
        <div class="sixteen columns bottom-4">
          <p>
            {{ $t('ref_project_intro') }}
          </p>
        </div>
        </div>

        <div class="row">
          <div v-for="(project,index) in projects" :key="index">
            <div class="eight columns bottom-4">
              <h3 class="title">{{ $t(project.main) }}</h3>
              <p v-html="$t(project.text)"></p>
            </div>
            <div class="sixteen columns clearfix"
                 v-if="index % 2">
            </div>
          </div>
        </div>

        <contact-banner :ctatext="$t('banner_ctatext1')"></contact-banner>

      </div>
    </div>
  </div>
</template>

<script>
import ContactBanner from '../utilities/ContactBanner'

export default {
  name: 'References',
  components: { ContactBanner },
  data () {
    return {
      projects: [
        {
          main: 'ref_project_main_1',
          text: 'ref_project_text_1'
        },
        {
          main: 'ref_project_main_2',
          text: 'ref_project_text_2'
        },
        {
          main: 'ref_project_main_3',
          text: 'ref_project_text_3'
        },
        {
          main: 'ref_project_main_4',
          text: 'ref_project_text_4'
        },
        {
          main: 'ref_project_main_5',
          text: 'ref_project_text_5'
        },
        {
          main: 'ref_project_main_6',
          text: 'ref_project_text_6'
        },
        {
          main: 'ref_project_main_7',
          text: 'ref_project_text_7'
        },
        {
          main: 'ref_project_main_8',
          text: 'ref_project_text_8'
        }
      ],
      testimonials: [
        {
          text: 'ref_test_text_1',
          name: 'Marleen Hemmeryckx',
          title: 'ref_test_auth_1'
        },
        {
          text: 'ref_test_text_2',
          name: 'Tamás Kapócs',
          title: 'ref_test_auth_2'
        },
        {
          text: 'ref_test_text_9',
          name: 'Jacques Bus',
          title: 'ref_test_auth_9'
        },
        {
          text: 'ref_test_text_3',
          name: 'Irwin Oedayrajsingh Varma',
          title: 'ref_test_auth_3'
        },
        {
          text: 'ref_test_text_4',
          name: 'Eva Spekman',
          title: 'ref_test_auth_4'
        },
        {
          text: 'ref_test_text_5',
          name: 'Robert Schmidt',
          title: 'ref_test_auth_5'
        },
        {
          text: 'ref_test_text_6',
          name: 'Zoltán Pádár',
          title: 'ref_test_auth_6'
        },
        {
          text: 'ref_test_text_7',
          name: 'Péter Bozsó',
          title: 'ref_test_auth_7'
        },
        {
          text: 'ref_test_text_8',
          name: 'István Bartus',
          title: 'ref_test_auth_8'
        }
      ]
    }
  }
}
</script>

<style>
</style>
